/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_LedeInputs */



/**
* | output |
* | --- |
* | "XP counted from the same record as the analytics: see how long each level takes before you save, reward the members who keep your server going, and bring eve..." |
*
* @param {Products_Leveling_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_lede = /** @type {((inputs?: Products_Leveling_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP считается по тем же данным, что и аналитика. Ещё до сохранения видно, сколько времени займёт каждый уровень. Награждайте тех, на ком держится сервер, и переносите все уровни из старого бота.")
	return /** @type {LocalizedString} */ ("XP counted from the same record as the analytics: see how long each level takes before you save, reward the members who keep your server going, and bring every level over from your old bot.")
});